import * as yup from 'yup';

export const schema = (messages: any) =>
  yup.object().shape({
    name: yup
      .string()
      .trim()
      .required(messages['countries.validate.create.name'].toString()),
    twoLetterIsoCode: yup
      .string()
      .min(
        2,
        messages['countries.validate.create.twoLetterIsoCode.min'].toString(),
      )
      .max(
        2,
        messages['countries.validate.create.twoLetterIsoCode.max'].toString(),
      )
      .required(
        messages[
          'countries.validate.create.twoLetterIsoCode.required'
        ].toString(),
      ),
    threeLetterIsoCode: yup
      .string()
      .min(
        3,
        messages['countries.validate.create.threeLetterIsoCode.min'].toString(),
      )
      .max(
        3,
        messages['countries.validate.create.threeLetterIsoCode.max'].toString(),
      )
      .required(
        messages[
          'countries.validate.create.threeLetterIsoCode.required'
        ].toString(),
      ),
  });
